import type { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { DonorActions } from './DonorActions'

export type DonorRow = {
  id: number
  name: string
  donor_type: 'individual' | 'organization'
  email: string | null
  phone: string | null
  status: { value: number; label: string }
  discarded?: boolean
}

function statusVariant(value: number): 'outline' | 'default' | 'secondary' {
  switch (value) {
    case 0: return 'outline'    // prospect
    case 1: return 'default'    // active
    case 2: return 'secondary'  // inactive
    default: return 'outline'
  }
}

export const donorColumns: ColumnDef<DonorRow, unknown>[] = [
  {
    accessorKey: 'name',
    header: 'Nom',
  },
  {
    accessorKey: 'donor_type',
    header: 'Type',
    cell: ({ row }) => {
      const type = row.original.donor_type
      return (
        <Badge variant={type === 'individual' ? 'outline' : 'secondary'}>
          {type === 'individual' ? 'Individuel' : 'Organisation'}
        </Badge>
      )
    },
  },
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row }) => row.original.email ?? '—',
  },
  {
    accessorKey: 'phone',
    header: 'Telephone',
    cell: ({ row }) => row.original.phone ?? '—',
  },
  {
    accessorKey: 'status',
    header: 'Statut',
    cell: ({ row }) => {
      const { value, label } = row.original.status
      return <Badge variant={statusVariant(value)}>{label}</Badge>
    },
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) =>
      row.original.discarded ? null : <DonorActions donor={row.original} />,
  },
]
